import React, { ReactNode } from "react";
import { useAppSelector } from "redux/hooks";
import { ThemeProvider as StyledComponentThemeProvider } from "styled-components/macro";

function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useAppSelector((state) => state.theme.currentTheme);
  return (
    <StyledComponentThemeProvider theme={theme}>
      {children}
    </StyledComponentThemeProvider>
  );
}

export default ThemeProvider;
